import { render, staticRenderFns } from "./BeneficialInterest.vue?vue&type=template&id=a1af2264&scoped=true"
import script from "./BeneficialInterest.vue?vue&type=script&lang=js"
export * from "./BeneficialInterest.vue?vue&type=script&lang=js"
import style0 from "./BeneficialInterest.vue?vue&type=style&index=0&id=a1af2264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1af2264",
  null
  
)

export default component.exports